export const getNotificationState = state => state.notifications;
